export default "div.error[data-v-2b2c253c] {\n  color: red;\n  font-size: 0.8em;\n}\n"